export const withoutStockText = (t) => {
    return t('efficientPurchasing.comparative.labelCellOutOfStock');
};
